"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _state = _interopRequireDefault(require("@/libs/state"));
const methods = {
  props: {},
  toggleSelfAway(props) {
    // let props = this.props;
    if (props.isUserSelf) {
      let val = props.user.isAway();
      props.network.ircClient.raw('AWAY', val ? '' : 'Absent');
    }
  },
  isUserSelf(props) {
    // let props = this.props;
    if (props.toggle === false) {
      return false;
    }
    let user = (0, _state.default)().getUser(props.network.id, props.network.nick);
    return props.user === user;
  },
  shouldShowStatus(props) {
    // let props = this.props;
    if (!(0, _state.default)().setting('showAwayStatusIndicators')) {
      return false;
    }
    if (props.network.state !== 'connected') {
      return false;
    }
    let awayNotifyEnabled = props.network.ircClient.network.cap.isEnabled('away-notify');
    return (0, _state.default)().setting('buffers.who_loop') || awayNotifyEnabled;
  }
};
var _default = exports.default = {
  props: {
    network: Object,
    user: Object,
    toggle: Boolean
  },
  m: methods
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["AwayStatusIndicator"]
window._app_exports.components.AwayStatusIndicator = exports.default ? exports.default : exports;
